<lds-info-modal
  [variant]="this.modalType"
  [title]="this.titleTransKey | translate"
  [text]="this.infoTextTransKey | translate"
  [confirmBtnText]="this.confirmBtnTextTransKey | translate"
  [cancelBtnText]="this.cancelBtnTextTransKey | translate"
  [isCancelBtnHidden]="this.isCancelBtnHidden"
  [open]="isOpen()"
  (close)="onModalClose($event)"
></lds-info-modal>
